(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-modern"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-modern"] && !Shopify.designMode) return;
  try {
    

(() => {

  function initializeModernProduct(section) {

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    const mainImage =
      section.querySelector(
        '.modern-main-product__main-image'
      );

    const thumbnails =
      section.querySelectorAll(
        '[data-modern-thumbnail]'
      );

    const optionSelectors =
      section.querySelectorAll(
        '[data-modern-option]'
      );

    const variantInput =
      section.querySelector(
        '[data-modern-variant-id]'
      );

    const priceElement =
      section.querySelector(
        '[data-modern-price]'
      );

    const comparePriceElement =
      section.querySelector(
        '[data-modern-compare-price]'
      );

    const skuElement =
      section.querySelector(
        '[data-modern-sku]'
      );

    const addButton =
      section.querySelector(
        '[data-modern-add-button]'
      );

    const addText =
      section.querySelector(
        '[data-modern-add-text]'
      );

    const quantityInput =
      section.querySelector(
        '[data-modern-quantity]'
      );

    const quantityMinus =
      section.querySelector(
        '[data-modern-quantity-minus]'
      );

    const quantityPlus =
      section.querySelector(
        '[data-modern-quantity-plus]'
      );

    const variantsJSON =
      section.querySelector(
        '[data-modern-variants]'
      );

    let variants = [];

    if (variantsJSON) {
      try {
        variants =
          JSON.parse(
            variantsJSON.textContent
          );
      } catch (error) {
        console.error(
          'Unable to parse product variants',
          error
        );
      }
    }


    function formatMoney(cents) {

      const currency =
        section.dataset.currency || 'USD';

      try {

        return new Intl.NumberFormat(
          document.documentElement.lang || 'en',
          {
            style: 'currency',
            currency: currency
          }
        ).format(cents / 100);

      } catch (error) {

        return (cents / 100).toFixed(2);

      }

    }


    thumbnails.forEach((thumbnail) => {

      thumbnail.addEventListener(
        'click',
        () => {

          if (!mainImage) {
            return;
          }

          const newSrc =
            thumbnail.dataset.imageSrc;

          if (!newSrc) {
            return;
          }

          mainImage.src = newSrc;

          mainImage.removeAttribute('srcset');

          thumbnails.forEach((item) => {
            item.classList.remove('is-active');
          });

          thumbnail.classList.add('is-active');

        }
      );

    });


    function getSelectedOptions() {

      return Array.from(optionSelectors)
        .map((select) => select.value);

    }


    function getSelectedVariant() {

      const selectedOptions =
        getSelectedOptions();

      return variants.find((variant) => {

        return variant.options.every(
          (option, index) =>
            option === selectedOptions[index]
        );

      });

    }


    function updateVariant() {

      const variant =
        getSelectedVariant();

      if (!variant) {

        if (addButton) {
          addButton.disabled = true;
        }

        if (addText) {
          addText.textContent =
            'Unavailable';
        }

        return;
      }


      if (variantInput) {
        variantInput.value = variant.id;
      }


      if (priceElement) {
        priceElement.textContent =
          formatMoney(variant.price);
      }


      if (comparePriceElement) {

        if (
          variant.compare_at_price &&
          variant.compare_at_price >
            variant.price
        ) {

          comparePriceElement.textContent =
            formatMoney(
              variant.compare_at_price
            );

          comparePriceElement.hidden =
            false;

        } else {

          comparePriceElement.hidden =
            true;

        }

      }


      if (skuElement) {

        if (variant.sku) {

          skuElement.textContent =
            `SKU: ${variant.sku}`;

          skuElement.hidden = false;

        } else {

          skuElement.hidden = true;

        }

      }


      if (addButton) {

        addButton.disabled =
          !variant.available;

      }


      if (addText) {

        addText.textContent =
          variant.available
            ? 'Add to cart'
            : 'Sold out';

      }


      if (
        mainImage &&
        variant.featured_image
      ) {

        mainImage.src =
          variant.featured_image;

        mainImage.removeAttribute(
          'srcset'
        );

      }


      if (
        window.history &&
        variant.url
      ) {

        window.history.replaceState(
          {},
          '',
          variant.url
        );

      }

    }


    optionSelectors.forEach(
      (selector) => {

        selector.addEventListener(
          'change',
          updateVariant
        );

      }
    );


    if (quantityMinus && quantityInput) {

      quantityMinus.addEventListener(
        'click',
        () => {

          const current =
            parseInt(
              quantityInput.value,
              10
            ) || 1;

          quantityInput.value =
            Math.max(1, current - 1);

        }
      );

    }


    if (quantityPlus && quantityInput) {

      quantityPlus.addEventListener(
        'click',
        () => {

          const current =
            parseInt(
              quantityInput.value,
              10
            ) || 1;

          quantityInput.value =
            current + 1;

        }
      );

    }

  }


  function initializeAllModernProducts() {

    document
      .querySelectorAll(
        '[data-modern-product]'
      )
      .forEach(
        initializeModernProduct
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAllModernProducts
    );

  } else {

    initializeAllModernProducts();

  }


  document.addEventListener(
    'shopify:section:load',
    initializeAllModernProducts
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-modern"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const initializeRecommendations = () => {

      const recommendationSections =
        document.querySelectorAll(
          '[data-modern-product-recommendations]'
        );

      recommendationSections.forEach((section) => {

        if (
          section.dataset.loaded === 'true' ||
          section.dataset.loading === 'true'
        ) {
          return;
        }

        const url = section.dataset.url;

        if (!url) {
          return;
        }

        const loadRecommendations = () => {

          section.dataset.loading = 'true';

          fetch(url)
            .then((response) => {

              if (!response.ok) {
                throw new Error(
                  'Unable to load product recommendations.'
                );
              }

              return response.text();

            })
            .then((text) => {

              const parser = new DOMParser();

              const documentHTML =
                parser.parseFromString(
                  text,
                  'text/html'
                );

              const replacement =
                documentHTML.querySelector(
                  '[data-modern-product-recommendations]'
                );

              if (
                replacement &&
                replacement.innerHTML.trim().length
              ) {

                section.innerHTML =
                  replacement.innerHTML;

                section.dataset.loaded = 'true';

              }

            })
            .catch((error) => {

              console.error(
                'Product recommendations:',
                error
              );

            })
            .finally(() => {

              section.dataset.loading = 'false';

            });

        };


        if ('IntersectionObserver' in window) {

          const observer =
            new IntersectionObserver(
              (entries, currentObserver) => {

                if (!entries[0].isIntersecting) {
                  return;
                }

                currentObserver.unobserve(section);

                loadRecommendations();

              },
              {
                rootMargin: '0px 0px 250px 0px'
              }
            );

          observer.observe(section);

        } else {

          loadRecommendations();

        }

      });

    };


    if (document.readyState === 'loading') {

      document.addEventListener(
        'DOMContentLoaded',
        initializeRecommendations,
        {
          once: true
        }
      );

    } else {

      initializeRecommendations();

    }


    document.addEventListener(
      'shopify:section:load',
      initializeRecommendations
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
